import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUsersSelected = createSelector(
    [
        (store: RootState) => store.profileDetail.selectedUsers,
    ],
    (selectedUsers) => [...selectedUsers].sort((a, b) => {
        if (a.name && b.name && a.name < b.name) {
          return -1;
        }
        if (a.name && b.name && a.name > b.name) {
          return 1;
        }
        return 0;
      })
);
